import React from 'react';
import { OrganisationMasterScreen } from '../organisation/OrganisationMasterScreen';
import { financialYearDefinition } from '../organisation/organisationDefinitions';

interface Props { moduleIcon?: string; tabId?: string; moduleName?: string }

/** Financial years of a tenant — the organisation master (standard §7.4.1, §7.5). */
const FinancialYearMasterScreen: React.FC<Props> = (props) => (
  <OrganisationMasterScreen definition={financialYearDefinition} {...props} />
);

export default FinancialYearMasterScreen;
